import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString } from "vue";
const _hoisted_1 = {
  class: "dibuall"
};
const _hoisted_2 = {
  class: "dibu"
};
const _hoisted_3 = {
  class: "dibu_one acea-row row-between-wrapper"
};
const _hoisted_4 = {
  class: "dibu_one_yi"
};
const _hoisted_5 = {
  class: "dibu_rexian"
};
const _hoisted_6 = {
  key: 0
};
const _hoisted_7 = {
  key: 1
};
const _hoisted_8 = {
  class: "dibu_tel"
};
const _hoisted_9 = {
  class: "dibu_zongbu"
};
const _hoisted_10 = {
  key: 0
};
const _hoisted_11 = {
  key: 1
};
const _hoisted_12 = {
  class: "dibu_dizhi"
};
const _hoisted_13 = {
  key: 0
};
const _hoisted_14 = {
  key: 1
};
const _hoisted_15 = {
  class: "dibu_one_er"
};
const _hoisted_16 = {
  class: "dibu_title"
};
const _hoisted_17 = {
  key: 0
};
const _hoisted_18 = {
  key: 1
};
const _hoisted_19 = {
  key: 0
};
const _hoisted_20 = {
  key: 1
};
const _hoisted_21 = {
  key: 0
};
const _hoisted_22 = {
  key: 1
};
const _hoisted_23 = {
  class: "dibu_one_san"
};
const _hoisted_24 = {
  key: 0
};
const _hoisted_25 = {
  key: 1
};
const _hoisted_26 = {
  key: 0
};
const _hoisted_27 = {
  key: 1
};
const _hoisted_28 = {
  class: "dibu_three"
};
const _hoisted_29 = {
  key: 0
};
const _hoisted_30 = {
  key: 1
};
const _hoisted_31 = {
  href: "https://beian.miit.gov.cn/",
  target: "_blank"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createElementVNode("div", _hoisted_4, [_createElementVNode("div", _hoisted_5, [$props.xzlag == 1 ? (_openBlock(), _createElementBlock("span", _hoisted_6, "Service Tel")) : _createCommentVNode("", true), $props.xzlag == 2 ? (_openBlock(), _createElementBlock("span", _hoisted_7, "服务热线")) : _createCommentVNode("", true)]), _createElementVNode("div", _hoisted_8, _toDisplayString($data.peizhiinfo.kefutel), 1), _createElementVNode("div", _hoisted_9, [$props.xzlag == 1 ? (_openBlock(), _createElementBlock("span", _hoisted_10, "Address")) : _createCommentVNode("", true), $props.xzlag == 2 ? (_openBlock(), _createElementBlock("span", _hoisted_11, "地址")) : _createCommentVNode("", true)]), _createElementVNode("div", _hoisted_12, [$props.xzlag == 1 ? (_openBlock(), _createElementBlock("span", _hoisted_13, _toDisplayString($data.peizhiinfo.dizhi_en), 1)) : _createCommentVNode("", true), $props.xzlag == 2 ? (_openBlock(), _createElementBlock("span", _hoisted_14, _toDisplayString($data.peizhiinfo.dizhi), 1)) : _createCommentVNode("", true)])]), _createElementVNode("div", _hoisted_15, [_createElementVNode("div", _hoisted_16, [$props.xzlag == 1 ? (_openBlock(), _createElementBlock("span", _hoisted_17, "CLASSIFICATION")) : _createCommentVNode("", true), $props.xzlag == 2 ? (_openBlock(), _createElementBlock("span", _hoisted_18, "分类")) : _createCommentVNode("", true)]), _createElementVNode("div", {
    class: "dibu_item",
    onClick: _cache[0] || (_cache[0] = $event => $options.goxwlist(2, 5))
  }, [$props.xzlag == 1 ? (_openBlock(), _createElementBlock("span", _hoisted_19, "NEWS")) : _createCommentVNode("", true), $props.xzlag == 2 ? (_openBlock(), _createElementBlock("span", _hoisted_20, "公司新闻")) : _createCommentVNode("", true)]), _createElementVNode("div", {
    class: "dibu_item",
    onClick: _cache[1] || (_cache[1] = $event => $options.goxinwen(1, 7))
  }, [$props.xzlag == 1 ? (_openBlock(), _createElementBlock("span", _hoisted_21, "ABOUT")) : _createCommentVNode("", true), $props.xzlag == 2 ? (_openBlock(), _createElementBlock("span", _hoisted_22, "关于我们")) : _createCommentVNode("", true)])]), _createElementVNode("div", _hoisted_23, [_createElementVNode("div", {
    class: "dibu_title",
    onClick: _cache[2] || (_cache[2] = $event => $options.goxinwen(1, 7))
  }, [$props.xzlag == 1 ? (_openBlock(), _createElementBlock("span", _hoisted_24, "ABOUT")) : _createCommentVNode("", true), $props.xzlag == 2 ? (_openBlock(), _createElementBlock("span", _hoisted_25, "关于我们")) : _createCommentVNode("", true)]), _createElementVNode("div", {
    class: "dibu_item",
    onClick: _cache[3] || (_cache[3] = $event => $options.goxinwen(1, 7))
  }, [$props.xzlag == 1 ? (_openBlock(), _createElementBlock("span", _hoisted_26, "INTRODUCTION")) : _createCommentVNode("", true), $props.xzlag == 2 ? (_openBlock(), _createElementBlock("span", _hoisted_27, "柏宇亿诺介绍")) : _createCommentVNode("", true)])])]), _createElementVNode("div", _hoisted_28, [$props.xzlag == 1 ? (_openBlock(), _createElementBlock("span", _hoisted_29, "Copyright©2026-2027 " + _toDisplayString($data.peizhiinfo.site_name_en), 1)) : _createCommentVNode("", true), $props.xzlag == 2 ? (_openBlock(), _createElementBlock("span", _hoisted_30, "版权所有©2026-2027 " + _toDisplayString($data.peizhiinfo.site_name), 1)) : _createCommentVNode("", true), _createElementVNode("a", _hoisted_31, _toDisplayString($data.peizhiinfo.beianhao), 1)])])]);
}